import request from "../utils/request";
import realRequest from "../utils/realRequest";
import { uploadFileDirect } from "../utils/directCloudUpload";
//获取所有国家列表
export function getCountry() {
  return request({
    url: `/country/all`,
    method: "get",
  });
}
//上传文件
export function uploadFile(params, config = {}) {
  const direct = uploadFileDirect(params, config)
  if (direct) {
    return direct
  }
  return request({
    url: "/uploadFile/upload",
    method: "post",
    data: params,
  });
}
//查所有分类
export function getAllCategory(name, type = 1) {
  var url = "/category/listNoPage?type=" + type;
  if (name) {
    url += "&name=" + name;
  }

  return request({
    url,
    method: "get",
  });
}

//获取所有的数据集
export function getAllDataList() {
  return request({
    url: "/dataset/all",
  });
}

//上传zip文件并返回url
export function uploadZip(params, id, resourceName = "wallpaper") {
  return request({
    url: `/${resourceName}/uploadZip?userId=${id}`,
    method: "post",
    data: params,
  });
}

//获取所有样式
export function getAllStyle() {
  return request({
    url: "/style/all",
    method: "get",
  });
}
//获取所有的分类
export function getCategoryAll() {
  return request({
    url: "/category/all",
    method: "get",
  });
}
// 资源包下载接口
export function downloadResourceZip(params) {
  return request({
    url: "/wallpaper/downloadResourceZip",
    method: "post",
    data: params,
  });
}

//通过id查询壁纸详细信息
export function getQueryNameById(params) {
  return request({
    url: `/${params.queryName}/getWallpaperById?id=${params.id}`,
    method: "get",
  });
}

//设计师列表接口(新增接口)
export function getAllDesignerOptionCreate() {
  return request({
    url: `/designer/listNoPage`,
    method: "get",
  });
}


//资源导出
export function exportResourceList(params) {
  return realRequest({
    url: `/wallpaper/exportResourceList`,
    method: "post",
    data: params,
    responseType: "blob",
  });
}

//资源导入
export function importResourceList(params) {
  return realRequest({
    url: `/wallpaper/importResourceList`,
    method: "post",
    data: params,
  });
}

// 分片上传
export function sliceUpload(params) {
  return realRequest({
    url: `/uploadFile/sliceUpload`,
    method: "post",
    data: params,
  });
}

// 获取所有分类的名称
export function getClassifyResourceType() {
  return realRequest({
    url: `/resourceType/list`,
    method: "get",
  });
}


// 获取用户权限
export function getUserRole(){
  return request({
    url: `/user/getRole`,
    method: "get"
  });
}


// 资源下所有的标签
export function getResourceAllTags(params){
  const queryString = Object.keys(params)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');
  return request({
    url: `/tag/simpleAll?${queryString}`,
    method: "get",
  });
}